import axios, { type AxiosResponse } from "axios";
import {
  TaxonomyCountryItemSchema,
  TaxonomyRoleItemSchema,
} from "@/schemas/index";
import { TaxonomyStateItemSchema } from "@/schemas/taxonomy/taxonomy-state-item";
import type {
  TaxonomyCountryItemType,
  TaxonomyRoleItemType,
} from "@/schemas/index";
import type { TaxonomyStateItemType } from "@/schemas/taxonomy/taxonomy-state-item";
import env from "@/app/config/env";

export interface ServiceTaxonomyApiType {
  fetchTaxonomyCountries: () => Promise<TaxonomyCountryItemType[]>;
  fetchTaxonomyStates: (
    countryName: string,
  ) => Promise<TaxonomyStateItemType[]>;
  fetchTaxonomyRoles: () => Promise<TaxonomyRoleItemType[]>;
}

export const serviceTaxonomyApi: ServiceTaxonomyApiType = {
  fetchTaxonomyCountries: () => {
    return axios
      .get(`${env.services.portal}/taxonomy/countries`)
      .then((response: AxiosResponse<unknown[]>) => {
        return response?.data?.map((item) =>
          TaxonomyCountryItemSchema.parse(item),
        );
      });
  },

  fetchTaxonomyStates: (countryName) => {
    return axios
      .get(`${env.services.portal}/taxonomy/states`, {
        params: { countryName },
      })
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item) => TaxonomyStateItemSchema.parse(item)) ||
          []
        );
      });
  },

  fetchTaxonomyRoles: () => {
    return axios
      .get(`${env.services.portal}/taxonomy/roles`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((item) => TaxonomyRoleItemSchema.parse(item)) || []
        );
      });
  },
};
